/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";
import { Button, Card, CardContent, DialogActions, DialogContent, Grid, IconButton, Menu, MenuItem, Typography } from "@material-ui/core";
import { Delete, Edit, MoreVert } from "@material-ui/icons";
import PopupState, { bindHover, bindMenu, bindTrigger } from "material-ui-popup-state";
import HoverMenu from "material-ui-popup-state/HoverMenu";
import { PopupState as PopupStateType } from "material-ui-popup-state/core";
import { useWindowSize } from "pages/eligibility/components/form/form-layout";
import { Modal } from "components/haven-design";
import BuildingForm, { BuildingType } from "./building-form";
import BuildingDetailsShort from "./building-details-short";
import BuildingDetailsModal from "./building-details";

type BuildingItemActionsType = BuildingType & {
  editBuilding: () => void
  deleteBuildng: () => void
  handleDetailsOpen: () => void
}

const BuildingItemActionsMenu: React.FC<BuildingItemActionsType & {
  popupState: PopupStateType
}> = ({ popupState, editBuilding, deleteBuildng }) => <>
  <MenuItem onClick={() => {
    editBuilding();
    popupState.close();
  }}
  >
    <Edit />&nbsp; Edit Building
  </MenuItem>
  <MenuItem
    onClick={() => {
      deleteBuildng();
      popupState.close();
    }}
    className="color-hc-error"
  >
    <Delete />&nbsp; Delete
  </MenuItem>
</>;

const ManageUnitsButton: React.FC<{handleDetailsOpen: () => void}> =
({ handleDetailsOpen }) =>
  <Button variant="outlined" color="primary" onClick={handleDetailsOpen}>Manage Units</Button>;

const BuildingItemActions: React.FC<BuildingItemActionsType> = (props) => {
  const { id } = props;
  const [isMobile, setIsMobile] = useState(window.outerWidth <= 695);
  const size = useWindowSize();
  useEffect(() => setIsMobile(size.width < 960), [size]);
  return (
    <PopupState variant="popover" popupId={`building-menu-${id}`}>
      {(popupState) => (isMobile ? (<>
        <ManageUnitsButton {...props} />
        <IconButton color="primary" size="small"
          {...bindTrigger(popupState)}
        >
          <MoreVert />
        </IconButton>
        <Menu {...bindMenu(popupState)}>
          <BuildingItemActionsMenu popupState={popupState} {...props} />
        </Menu>
      </>) : (
        <>
          <ManageUnitsButton {...props} />
          <IconButton color="primary" size="small"
            {...bindHover(popupState)}
          >
            <MoreVert />
          </IconButton>
          <HoverMenu {...bindMenu(popupState)}>
            <BuildingItemActionsMenu popupState={popupState} {...props} />
          </HoverMenu>
        </>)
      )}
    </PopupState>);
};

const BuildingItem: React.FC<BuildingType & {
  updateBuilding: (input: BuildingType) => void
  deleteBuilding: (id: string) => void
}> =
({ updateBuilding, deleteBuilding, ...building }) => {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openDelete, setDeleteOpen] = useState(false);
  const handleDeleteOpen = () => setDeleteOpen(true);
  const handleDeleteClose = () => setDeleteOpen(false);

  const handleDetailsOpen = () => setDetailsOpen(true);
  const handleDetailsClose = () => setDetailsOpen(false);

  return <>
    <Card variant="outlined">
      <CardContent>
        <Grid container>
          <BuildingDetailsShort {...building} />
          <Grid item container xs={12} sm={3} xl={2} justifyContent="flex-end" alignContent="center">
            <BuildingItemActions {...building}
              editBuilding={handleOpen}
              deleteBuildng={handleDeleteOpen}
              handleDetailsOpen={handleDetailsOpen}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
    <Modal
      isOpen={open}
      onRequestClose={handleClose}
      title="Update Building"
      fullScreen
    >
      <DialogContent>
        <BuildingForm
          id={`update-buliding-form-${building.id}`}
          initialValues={building}
          onSubmit={(data) => {
            updateBuilding(data);
            handleClose();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button size="large" color="secondary" variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          size="large"
          color="primary"
          variant="contained"
          type="submit"
          form={`update-buliding-form-${building.id}`}
        >
          Update Building
        </Button>
      </DialogActions>
    </Modal>
    <Modal
      isOpen={openDelete}
      onRequestClose={handleDeleteClose}
      title="Delete Building"
    >
      <DialogContent>
        <Typography variant="subtitle1">
          Are you sure you want to delete this building and all the associated units?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button size="large" color="secondary" variant="outlined" onClick={handleDeleteClose}>
          Cancel
        </Button>
        <Button
          size="large"
          color="primary"
          variant="contained"
          className="color-bk-error"
          onClick={() => deleteBuilding(building.id)}
        >
          Delete Building
        </Button>
      </DialogActions>
    </Modal>
    <BuildingDetailsModal {...building} open={detailsOpen} handleClose={handleDetailsClose} />
  </>;
};

export default BuildingItem;
